import React from 'react'
import MemberTaskBar from '../MemberTaskBar'
import { useMemberTaskBar } from '../useMemberTaskBar'

type MemberTaskBarEpisodeProps = {
  episodeId?: string
}

const MemberTaskBarEpisode = ({ episodeId }: MemberTaskBarEpisodeProps) => {
  const tasks = useMemberTaskBar(episodeId)

  return <MemberTaskBar tasks={tasks} />
}

export default MemberTaskBarEpisode
